const pageProductInfo = () => {
  setTimeout(() => {
    // Remove Info from List
    const items = document.querySelectorAll(".product-hero__info-item");
    if (items) {
      removeItemsFromList(items);
    }
  }, 1000);
};

export default pageProductInfo;

/**
 * Remove Info from List
 *
 * @param array items
 */

const removeItemsFromList = (items) => {
  if (items) {
    items.forEach((item) => {
      const titleElement = item.querySelector(".product-info__title");
      if (titleElement) {
        const title = titleElement.innerHTML.toLowerCase();
        if (title === "longevità" || title === "momento di consumo") {
          item.classList.add("d-none");
        }
        if (title === "info") {
          titleElement.innerHTML = "Note";
        }
      }
    });
  } else {
    console.log("Missing params in function removeItemsFromList(slider)", [items]);
  }
};
